<template>
  <div class="ly3" style="position:relative" v-show="contentShow" v-loading="loading" :element-loading-text="loadingText">
    <div class="ly3-left">
      <div class="search-form-group">
          <!-- <span class="redbox"></span> -->
          <span class="checkTitle">请选择时间段：</span>
           <el-date-picker
            v-model="pavingDate1"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateChange"
            placeholder="请选择开始时间">
          </el-date-picker>
          <span> 至 </span>
          <el-date-picker
            v-model="pavingDate2"
            style="margin-right: 10px"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择结束时间">
          </el-date-picker>
          <!-- <el-date-picker
              v-model="pavingDate"
              type="datetimerange"
              unlink-panels
              style="margin-left: 10px; margin-right: 10px"
              start-placeholder="请选择开始时间"
              range-separator="至"
              end-placeholder="请选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerDisabled"> -->
          <!-- </el-date-picker> -->
          <el-button type="danger" @click="confirm" > &emsp;确认&emsp; </el-button>
          <el-button v-show="downloadExcelShow" class="download" type="warning" plain @click="downloadExcel" icon="el-icon-download">数据下载</el-button>
          <el-button v-show="!downloadExcelShow" class="download" type="warning" :loading="true" plain>下载..</el-button>
          <span class="moreTime" @mouseover="setMoreTimeShow">查看可选时间</span>
          <span class="notice"><span class="el-icon-info"></span>时间长度请勿超过1个小时哦~</span>
          <div class="timeCheckBox" v-if="moreTimeShow"  @mouseleave ="setMoreTimeHid">
            <div class="timeCheck1" v-if="timeList.length == 0">无数据</div>
            <div class="timeCheck" v-for="(item,index) in timeList" :key="index" @click="setTime(item)">
                起始 {{item.startTime}} 结束 {{item.endTime}}
            </div>
          
        </div>
      </div>
      <div style="border: 1px solid #E8E8E8;position:relative">
        <div class="redB"></div>
        <div class="redBTitle">轨迹</div>
        <ChartLine :chartOption="chartOption1" height="520px" />
      </div>
      
    </div>
    <div class="ly3-right" style="position:relative">
      <div class="typeContent">
        <span class="typeItem" v-for="(item,index) in legendList" :key="index" @click="getLegend(index)">
          <span class="typeColor" :style="{background: typeList[index] == 0 ?colorList[index]:'#e1e1e1'}"></span>
          <span>{{item}}</span>
        </span>
      </div>
      <GridLayout col="1">
        <div style="border: 1px solid #E8E8E8;position:relative;margin-top:50px">
          <div class="redB"></div>
          <div class="redBTitle">速度(km/h)</div>
          <ChartLinec :chartOption="chartOption2" height="250px" />
        </div>
        <div style="border: 1px solid #E8E8E8;position:relative">
          <div class="redB"></div>
          <div class="redBTitle">温度(℃)</div>
          <ChartLine :chartOption="chartOption3" height="250px" />
        </div>
        
      </GridLayout>
    </div>
  </div>
</template>

<script>
// import Rolling from "../../../../components/chart/rolling";
// import Compaction from "../../../../components/chart/compaction";
import '../../../../css/global.scss'
import ChartLine from "../../../../components/chart/line";
import ChartLinec from "../../../../components/chart/line7";
import {pavingQualityTrace,exportExcelpavingTrace,getWorkTimeList} from "../../../../utils/api";
import GridLayout from "../../../../components/layout/grid";
import {getDateSeconds1,getDateSecondsAfter,getDateSeconds,objSort,seriesTurn} from "../../../../utils/commons"
export default {
  data() {
    return {
      leftData: [],
      chartOption1: {},
      chartOption2: {},
      chartOption3: {},
      pavingDate1:getDateSeconds1(),
      pavingDate2:getDateSecondsAfter(),
      contentShow: true,
      loading:false,
      loadingText:'加载中..',
      timer:0, //定时器id
      moreTimeShow: false,
      timeList: [],
      legendList: [],
      typeList: [],
      colorList: ["#E96A5B", "#56BDFF","#5FDBA9","#F6C018","#FFA940"],
      downloadExcelShow: true,
    };
  },
  computed: {
    // workId() {
    //   return this.$store.getters["quality/activeWorkId"];
    // },
  },
  props:{
    activeIndex2Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
      workId:{
        type: Number,
      },
      workName:{
        type: String,
      }
    },
  created() {},
  watch:{
    activeIndex2Code: {
      handler(newVal) {
        console.log(newVal);
        // setTimeout(function(){
          if(newVal == 3){
            this.contentShow = true
          }else{
            this.contentShow = false
          }
        // },100)
      },
      deep: true,
      // immediate: true,
    },
    workId: {
      handler() {
        this.getTimeCheckList()
      },
      deep: true,
      // immediate: true,
    },
  },
  mounted() {
    this.getData();
    this.getTimeCheckList()
  },
  methods: {
    getLegend(data){
      var selectArr = this.legendList;
      let obj = {}
      if(this.typeList[data] == 0){
        this.$set(this.typeList,data,1)
        obj[selectArr[data]] = false;
      }else{
        this.$set(this.typeList,data,0)
        obj[selectArr[data]] = true;
      }
      console.log(obj)
      let timer=setTimeout(()=>{
        // this.chartOption1.legend.selected = obj;
        // this.chartOption2.legend.selected = obj;
        // this.chartOption3.legend.selected = obj;
        // this.loading=false

        this.$set(this.chartOption1.legend,"selected", obj)
        this.$set(this.chartOption2.legend,"selected", obj)
        this.$set(this.chartOption3.legend,"selected", obj)
        clearTimeout(timer)
      },100)
    },
    setMoreTimeShow(){
      this.moreTimeShow = true
    },
    setMoreTimeHid(){
      this.moreTimeShow = false
    },
    setTime(data){
      console.log(data)
      this.pavingDate1 = data.startTime
      this.pavingDate2 = data.endTime
      this.moreTimeShow = false
    },
    dateChange(val){
      let strtime=(val+'').replace(/-/g, '/');
      this.pavingDate2 = getDateSecondsAfter(strtime);
    },
    confirm(){
        if(this.pavingDate2<this.pavingDate1){
          this.$message({
            message: '结束时间大于开始时间，请重新选择！',
            type: 'warning'})
          return
        }
        this.getData();
    },
    getTimeCheckList: function(){
        let params = {
            workId: this.workId,
            dataType: 3,
        }
        getWorkTimeList(params).then(res=>{
            console.log(res)
            this.timeList = res.data.content.dataList
        })
    },
    async downloadExcel(){
        if(this.pavingDate2<this.pavingDate1){
          this.$message({
            message: '结束时间大于开始时间，请重新选择！',
            type: 'warning'})
          return
        }
        this.loadingText='下载中..'
        if(new Date(this.pavingDate2)-new Date(this.pavingDate1)>3600000){
          this.loadingText='时间跨度较长数据量可能较多，请耐心等待！'
        }
        this.downloadExcelShow = false
        this.loading=true;
        this.timer=setTimeout(()=>{this.loading=false;this.downloadExcelShow = true},60000)
        const InstructionManualvv = await exportExcelpavingTrace({workId: this.workId,startTime:this.pavingDate1,endTime:this.pavingDate2});
        
        if(!InstructionManualvv){
          this.loading=false
          this.downloadExcelShow = true
          clearTimeout(this.timer)
          return
        }

        let fileName = this.workName+'摊铺轨迹'+getDateSeconds()+'.xlsx';
        let blob = new Blob([InstructionManualvv.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});  
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href) //释放内存
        }
        this.loading=false
        this.downloadExcelShow = true
        clearTimeout(this.timer)
    },
    getData() {
      this.loadingText='加载中..',
      this.loading=true;
      this.timer=setTimeout(()=>{this.loading=false},60000)
      let params_trace = {
        workId: this.workId,
        startTime: this.pavingDate1,
        endTime: this.pavingDate2,
      }
      pavingQualityTrace(params_trace).then(res=>{
        let resData = res.data.content.info
        let minYData = res.data.content.info.minPile;
        let maxYData = res.data.content.info.maxPile;
        // let minYData = 27500
        // let maxYData = 28000
        if(resData.temperature==null){
          resData.temperature=[]
        }
        if(resData.trace==null){
          resData.trace=[]
        }
        if(resData.speed==null){
          resData.speed=[]
        }
        this.legendList=[]
        for(let i=0;i<resData.trace.length;i++){
          this.legendList.push(resData.trace[i].equipName)
          this.typeList.push(0)
        }
        const legend = resData.temperature.map((item) => {
          return item.equipName;
        });
        //   温度
        let series1 = resData.temperature.map((item) => {
          return {
            name: item.equipName,
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            data: objSort(item.subDataMap).map((key) => {
              return [key.time, key.value];
            })
          };
        });
        series1=seriesTurn(series1,resData.temperature);
        
        //   轨迹
        let series2 = resData.trace.map((item) => {
          return {
            name: item.equipName,
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            data: objSort(item.subDataMap).map((key) => {
              return [key.time, key.value];
            })
          };
        });
        series2=seriesTurn(series2,resData.trace);
        //   速度
        let series3 = resData.speed.map((item) => {
          return {
            name: item.equipName,
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            data: objSort(item.subDataMap).map((key) => {
              return [key.time, key.value];
            })
          };
        });
        series3=seriesTurn(series3,resData.speed);
        this.chartOption2 = this.getOption("速度(KM/H)", legend, series3,0,'', {
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
            color: "rgba(0,0,0,0.45)",
            // formatter: (v) => {
            //   return v ;
            // },
          },
        });
        console.log(JSON.stringify(this.chartOption2))
        this.chartOption1 = this.getOption("轨迹", legend, series2,minYData,maxYData, {
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
            color: "rgba(0,0,0,0.45)",
            formatter: function(value){
                  let texts = []
                  let getVal = ''
                  if(value < 0){
                    getVal = 'K'+'00'+'+'+'0'
                  }else if(value < 10){
                    getVal = 'K'+'00'+'+'+'00'+value
                  }else if(value<100){
                    getVal = 'K'+'00'+'+'+'0'+value
                  }else if(value<1000){
                    getVal = 'K'+'00'+'+'+value
                  }else if(value<10000){
                    getVal = 'K0'+Math.floor(value/1000)+'+'+Math.ceil((value*1-(Math.floor(value/1000)*1000)))
                  }else if(value<1000000){
                    getVal = 'K'+Math.floor(value/1000)+'+'+Math.ceil((value*1-(Math.floor(value/1000)*1000)))
                  }
                  texts.push(getVal)
                  return texts
                }
          },
        });
        this.chartOption3 = this.getOption("温度(°C)", legend, series1,'','', {
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
            color: "rgba(0,0,0,0.45)",
            // formatter: (v) => {
            //   return v ;
            // },
          },
        });
        console.log(this.chartOption3)
        console.log(this.chartOption2)
        this.loading=false;
        clearTimeout(this.timer)
      });
    },
    
    getOption(title, legend, series, minV, maxV, yAxis) {
      let obj={
        // title: { text: title },
        dataZoomEnd: Math.min(100, Math.ceil((8 / series.length) * 100)),
        legend: {
          data: legend,
          bottom: 1000
        },
        xAxis: [
          {
            type: "category",
            // type: "time",
            splitArea: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              lineStyle: {
                color: "rgba(0,0,0,0.45)",
              },
              color: "rgba(0,0,0,0.45)",
            },
            axisLine: {
              lineStyle: {
                color: "#E8E8E8",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [Object.assign(yAxis,{
          type: "value",
          name: "",
          splitArea: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
          
          axisTick: {
            show: false,
          }
        })],
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            handleSize: "10%",
            height: 10,
            handleStyle: {
              borderWidth: 2,
            },
            bottom: "10",
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          bottom: 50,
          top: 50,
          left: 70,
          right: 20
        },
        color: this.colorList,
        series: series,
      }
      if(minV){
        obj.yAxis[0].min=minV
      }
      if(maxV){
        obj.yAxis[0].max=maxV
      }
      return Object.assign(
        {},
        obj
      );
    },
  },
  components: {
    // LeftList,
    // Rolling,
    // Compaction,
    ChartLine,
    GridLayout,
    ChartLinec
  },
};
</script>

<style lang="scss" scoped="">
.ly3{
  display: flex;
}
.ly3-left{
  width: 75%;
}
.ly3-right{
  width: 24%;
  margin-left: 1%;
}
  .typeContent{
    display: inline-block;
    height: 60px;
    // width: 200px !important;
    // background-color: red;
    width: auto;
    position: absolute;
    top: 0;
    right: 0px;
    .typeItem{
        height: 60px;
        line-height: 60px;
        display: inline-block;
        color: rgba(0,0,0,0.65);
        margin-left: 10px;
        font-size: 12px;
        cursor: pointer;
        .typeColor{
          display: inline-block;
          height: 10px;
          width: 10px;
          background-color: rosybrown;
          margin-left: 5px;
          margin-right: 5px;
        }
      }
  }
  .search-form-group {
    // margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    .redbox{
        display: inline-block;
        width: 3px;
        height: 14px;
        background: red;
        line-height: 14px;
        margin-right: 5px;
    }
    .notice{
        color:#E96B5A;
        margin-left: 10px;
        font-size: 12px;
    }
    .timeCheckBox{
      position: absolute;
      width: 380px;
      height: auto;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      left: 750px;
      opacity: 1;
      z-index: 1000;
      padding: 12px;
      .timeCheck1{
        height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #777777;
          cursor: pointer;
          text-align: center;
      }
      .timeCheck{
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #777777;
          cursor: pointer;
      }
    }
    .moreTime{
        color:#777777;
        margin-left: 10px;
        font-size: 12px;
        cursor: pointer;
    }
    .checkTitle{
      font-size: 16px;
    }
  }
  .redB{
    width: 4px;
    height: 16px;
    background-color: #E96A5B;
    position: absolute;
    top: 28px;
    left: 24px;
  }
  .redBTitle{
    height: 24px;
    line-height: 24px;
    position: absolute;
    top: 24px;
    left: 36px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: bold;
    font-family: PingFangSC-Medium, PingFang SC;
  }
</style>